import axios from 'axios';
import Cookies from 'js-cookie';
import { authorByIdAction } from './AuthorByIdSlice';

const authorById = (authorId) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const token = Cookies.get('auth_token');
      const headers = { Authorization: `Bearer ${token}` };
      const url = `${process.env.REACT_APP_DEV_URI}/product/author/${authorId}`;
      const response = await axios.get(url, { headers });
      return response;
    };
    try {
      const authorById = await fetchData();
      dispatch(authorByIdAction.authorByIdHandler({ 'data': authorById.data }));
      return authorById
    } catch (e) {
      return e;
    }
  };
};

export default authorById;
